import { createActions } from "reduxsauce";

/**
 * We use reduxsauce's `createActions()` helper to easily create redux actions.
 *
 * Keys are action names and values are the list of parameters for the given action.
 *
 * Action names are turned to SNAKE_CASE into the `Types` variable. This can be used
 * to listen to actions:
 *
 * - to trigger reducers to update the state, for example in App/Stores/User/Reducers.js
 * - to trigger sagas, for example in App/Sagas/index.js
 *
 * Actions can be dispatched:
 *
 * - in React components using `dispatch(...)`, for example in App/App.js
 * - in sagas using `yield put(...)`, for example in App/Sagas/UserSaga.js
 *
 * @see https://github.com/infinitered/reduxsauce#createactions
 */
const { Types, Creators } = createActions({
  //show or hide universal loader
  setShowHideLoader: ["status"],
  //show or hide universal header title
  setHeaderTitle: ["headerTitle"],
  // Login user api call.
  //Classlink user
  classLinkLogin: ["loginId", "successFn", "failureFn"],
  // Login user.
  userLogin: ["username", "password", "domain", "successFn", "failureFn"],
  // The login success response
  userLoginSuccess: ["userResponse"],
  //set token data
  userToken: ["token"],
  //refresh token api call
  refreshToken: ["tokenData", "successFn", "failureFn"],
  //get courseList for user
  getCourseListForStudent: ["loginId", "token", "successFn", "failureFn"],
  getChapterListForStudent: [
    "subjectId",
    "loginId",
    "token",
    "successFn",
    "failureFn",
  ],
  getLessonFoldersForStudent: [
    "studentId",
    "DomainID",
    "SubjectID",
    "ChapterID",
    "token",
    "successFn",
    "failureFn",
  ],
  // get assignmentData response
  getAssignmentDataForStudent: [
    "studentId",
    "courseId",
    "lessonId",
    "ChapterID",
    "token",
    "successFn",
  ],
  // get assignmentDataSuccess response
  getAssignmentDataForStudentSuccess: ["assignmentData"],
  // get assignmentDataSummary response
  getAssignmentDataSummaryForStudent: [
    "studentId",
    "lessonUnitDistId",
    "successFn",
  ],
  // save assignmentDataSummarySuccess response
  saveAssignmentSummaryForStudentSuccess: ["assignmentDataSummary"],
  //get lessonUnitDetailsForStudent response
  getLessonUnitDetailsForStudent: [
    "studentId",
    "lessonUnitDistId",
    "token",
    "successFn",
  ],
  // save assignmentDataSummarySuccess response
  saveLessonUnitDetailsForStudent: ["lessonUnitDetails"],
  saveCompletedLessonUnitDetailsForStudent: ["completedlessonUnitDetails"],
  //save student activity
  saveActivityForStudent: ["token", "activity", "successFn"],

  unlockOfflineLessonUnit: ["unlocklesson", "successFn"],

  unlockOfflineCourse: ["unlockcourse", "successFn"],
  //get student activity
  getActivityForStudent: ["StudentID", "ContentID", "token", "successFn"],
  //get contained activity
  getContainedActivityForStudent: [
    "StudentID",
    "ContentID",
    "token",
    "successFn",
  ],
  // save backpack activity for student
  setCurrentActivityDetails: ["currentActivity"],
  // save contained activity for student
  setCurrentContainedActivityDetails: ["containedActivity"],
  //save current lesson dist id
  setCurrentLessonUnitDistId: ["currentLessonUnitDistId"],
  //setting current work json
  setWorkJson: ["WorkJson"],
  //setting current contained activity work json
  setContainedWorkJson: ["containedWorkJson"],

  //saving exercise list for the lesson
  setExerciseList: ["exerciseList", "successFn"],
  saveExerciseListInState: ["exerciseList"],

  //saving previous exerciseListForNavigation
  savePreviousExerciseInState: ["exerciseList"],
  setPreviousExerciseList: ["exerciseList", "successFn"],

  //current unit name
  saveUnitName: ["currentUnitName"],

  saveSubjectID: ["currentSubjectID"],
  //current course id
  saveCourseId: ["currentCourseId"],

  //from pending
  saveFromPending: ["fromPending"],

  //get upcoming assignment for user
  getUpcomingAssignmentForStudent: [
    "studentId",
    "assignmentDate",
    "token",
    "successFn",
  ],
  changeLoggedOutStatusInState: [],
  changeLoggedOutStatus: ["successFn"],
  setCurrentLessonName: ["currentLessonName"],
  // for forgot password
  forgotPasswordStudent: ["LoginName", "DomainName", "successFn"],
  // get lesson folders
  getLessonFolderBySubject: ["DomainID", "StudentID", "SubjectID", "successFn"],
  // get lesson units by lesson folder
  getLessonUnitsByFolder: ["StudentID", "LessonID", "successFn"],

  getCourseSummaryAnalyticsReport: [
    "DomainID",
    "CourseID",
    "StudentID",
    "successFn",
  ],
  // get CourseAnalyticslist response
  getCourseSummaryAnalyticsReportSuccess: ["CourseAnalytics"],
  getLessonPodSummaryAnalyticsReport: [
    "LessonUnitDistID",
    "StudentID",
    "successFn",
  ],

  getLessonPodSummaryAnalyticsReportSuccess: ["StudentLessonpodAnalytics"],
  // get ActivityAnalyticslist
  getLessonPodActivityAnalyticsReport: ["ContentID", "StudentID", "successFn"],
  // get ActivityAnalyticslist response
  getLessonPodActivityAnalyticsReportSuccess: ["StudentActivityAnalytics"],
  saveFromAnalytics: ["fromAnalytics"],
  saveFromCourse: ["fromCourse"],
  showOrHideToaster: ["showToastModal", "toastMessageText", "toastType"],
  onHeaderItemSelected: ["headerItemSelected"],
  setNavigationIndex: ["navigationIndex"],
  //save current course name
  saveCourseName: ["currentCourseName"],
  //hard Reset randon
  hardResetRandomActivity: ["hardResetRandom"],
  //Save selected class
  saveSelectedClass: ["selectedClass"],
  //Save selected chapter
  saveSelectedChapter: ["selectedChapter"],
  //Save selected folder
  saveSelectedFolder: ["selectedFolder"],
  //save current OS
  saveCurrentOSName: ["currentOSName"],
  //save current OS
  saveWalkthroughStatus: ["walkthroughStatus"],
  // chat Challenge.
  chatChallengeMe: [
    "serviceTypeName",
    "topic",
    "keyword",
    "question_type",
    "num_of_options",
    "content",
    "successFn",
    "failureFn",
  ],
  saveMuteStatus: ["muteStatus", "muteClicked"],
  //save tts api
  saveSpeechApi: ["speechApi"],
});

export const UserTypes = Types;
export default Creators;
